<div align="center">
    <form class="form">

            <img srcset="assets/images/conveyor_1_v1.gif" class="responsive"/>
         

    </form>
</div>